import React from 'react';
import Select, {createFilter} from 'react-select';
import clsx from 'clsx';
import {DefaultOption} from './option';
import Input from "../input/Input";

export const SelectInput = props => {
  const {
    required,
    name,
    error,
    options,
    value,
    onChange,
    disabled,
    onBlur,
    optionAs,
    appendToBody = false,
    innerRef,
    onSelect,
    isMulti = false,
    ...other
  } = props;

  return (
    <Input {...other} name={name} required={required} error={error} disabled={disabled}>
      <Select
        {...other}
        ref={innerRef}
        isClearable
        isDisabled={disabled}
        components={{Option: optionAs || DefaultOption}}
        filterOption={createFilter({ignoreAccents: false})}
        classNamePrefix="react-select"
        className={clsx('react-select-container', {'is-invalid': error})}
        options={options}
        placeholder="Seleccionar"
        menuPortalTarget={appendToBody ? document.body : null}
        isMulti={isMulti}
        value={isMulti
          ? value
          : options ? options.find((option) => option?.value === value) : ''
        }
        onBlur={() => {
          onBlur?.({
            target: {name},
          });
        }}
        onChange={(option) => {
          onBlur?.({
            target: {name},
          });

          onChange({
            target: {name, value: isMulti ? option : option?.value || ''},
          });

          onSelect?.(option);
        }}
        instanceId={name}
      />
    </Input>
  );
};
